import { darkColors, lightColors, profileClaudeLight, profileClaudeDark, spacing, radius, fontFamily, shadows, lightShadows, duration, easing, zIndex, borderWidth, opacity, iconSizes, typographyScale } from "../tokens";

function mapTypographyVars(scale) {
  const out = {};
  Object.entries(scale).forEach(([key, t]) => {
    const prefix = `--tra-font-${key}`;
    out[`${prefix}-size`] = `${t.size}px`;
    out[`${prefix}-line-height`] = String(t.lineHeight);
    out[`${prefix}-weight`] = String(t.weight);
    if (t.letterSpacing) {
      out[`${prefix}-letter-spacing`] = t.letterSpacing;
    }
  });
  return out;
}

function colorVars(palette) {
  return {
    "--tra-color-canvas": palette.canvas,
    "--tra-color-background": palette.background,
    "--tra-color-background-mid": palette.backgroundMid,
    "--tra-color-background-top": palette.backgroundTop,
    "--tra-color-surface": palette.surface,
    "--tra-color-surface-raised": palette.surfaceRaised,
    "--tra-color-border": palette.border,
    "--tra-color-border-strong": palette.borderStrong,
    "--tra-color-primary": palette.primary,
    "--tra-color-primary-muted": palette.primaryMuted,
    "--tra-color-on-primary": palette.onPrimary,
    "--tra-color-accent": palette.accent,
    "--tra-color-purple": palette.purple,
    "--tra-color-team-a": palette.teamA,
    "--tra-color-team-b": palette.teamB,
    "--tra-color-danger": palette.danger,
    "--tra-color-success": palette.success,
    "--tra-color-warning": palette.warning,
    "--tra-color-info": palette.info,
    "--tra-color-court-net": palette.courtNet,
    "--tra-color-border-bright": palette.borderBright,
    "--tra-color-text-dim": palette.textDim,
    "--tra-color-text": palette.text,
    "--tra-color-text-secondary": palette.textSecondary,
    "--tra-color-text-muted": palette.textMuted,
    "--tra-color-text-faint": palette.textFaint,
    "--tra-color-focus-ring": palette.focusRing,
  };
}

function baseTokenVars(shadowSet = shadows) {
  const space = {};
  Object.entries(spacing).forEach(([k, v]) => {
    space[`--tra-space-${k}`] = `${v}px`;
  });
  const rad = {};
  Object.entries(radius).forEach(([k, v]) => {
    rad[`--tra-radius-${k}`] = v === 9999 ? "9999px" : `${v}px`;
  });
  return {
    ...space,
    ...rad,
    "--tra-font-family-display": fontFamily.display,
    "--tra-font-family-body": fontFamily.body,
    "--tra-font-family-mono": fontFamily.mono,
    "--tra-font-family-numeric": fontFamily.numeric,
    "--tra-shadow-xs": shadowSet.xs,
    "--tra-shadow-sm": shadowSet.sm,
    "--tra-shadow-md": shadowSet.md,
    "--tra-shadow-lg": shadowSet.lg,
    "--tra-shadow-xl": shadowSet.xl,
    "--tra-shadow-focus": shadowSet.focus,
    "--tra-shadow-hover": shadowSet.hover,
    "--tra-shadow-overlay": shadowSet.overlay,
    "--tra-duration-fast": `${duration.fast}ms`,
    "--tra-duration-normal": `${duration.normal}ms`,
    "--tra-duration-slow": `${duration.slow}ms`,
    "--tra-easing-standard": easing.standard,
    "--tra-z-dropdown": String(zIndex.dropdown),
    "--tra-z-sticky": String(zIndex.sticky),
    "--tra-z-modal": String(zIndex.modal),
    "--tra-z-toast": String(zIndex.toast),
    "--tra-border-width-hairline": `${borderWidth.hairline}px`,
    "--tra-border-width-sm": `${borderWidth.sm}px`,
    "--tra-opacity-disabled": String(opacity.disabled),
    "--tra-opacity-overlay": String(opacity.overlay),
    "--tra-opacity-muted": String(opacity.muted),
    "--tra-icon-xs": `${iconSizes.xs}px`,
    "--tra-icon-sm": `${iconSizes.sm}px`,
    "--tra-icon-md": `${iconSizes.md}px`,
    "--tra-icon-lg": `${iconSizes.lg}px`,
    "--tra-icon-xl": `${iconSizes.xl}px`,
    "--tra-touch-min": "48px",
    ...mapTypographyVars(typographyScale),
  };
}

export const themes = {
  dark: {
    id: "dark",
    label: "Dark",
    cssVars: { ...baseTokenVars(shadows), ...colorVars(darkColors) },
  },
  light: {
    id: "light",
    label: "Light",
    cssVars: { ...baseTokenVars(lightShadows), ...colorVars(lightColors) },
  },
  profileLight: {
    id: "light",
    label: "Profile Light",
    cssVars: { ...baseTokenVars(lightShadows), ...colorVars(profileClaudeLight) },
  },
  profileDark: {
    id: "dark",
    label: "Profile Dark",
    cssVars: { ...baseTokenVars(shadows), ...colorVars(profileClaudeDark) },
  },
};

export const THEME_STORAGE_KEY = "tra-theme-mode";

export const themeModes = ["light", "dark", "system"];
